import { Icon, LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import { FC, ReactNode } from "react";

interface DisplayFieldProps {
  title: string;
  isLoading?: boolean;
  isTitleSemibold?: boolean;
  tooltip?: string;
  children: ReactNode;
}

export const DisplayField: FC<DisplayFieldProps> = ({ title, children, isLoading = false, isTitleSemibold = false, tooltip }) => {
  return (
    <Stack spacing="none">
      {isTitleSemibold ? (
        <Shelf spacing="mini">
          <Body size="small">
            <Semibold>{title} </Semibold>
          </Body>
          {tooltip && <Icon name="info-circle" tooltip={tooltip} />}
          <Shelf.Spacer />
        </Shelf>
      ) : (
        <Shelf>
          <Body size="small">{title}</Body>
          {tooltip && <Icon name="info-circle" tooltip={tooltip} />}
          <Shelf.Spacer />
        </Shelf>
      )}
      <LoadingGroup loading={isLoading}>
        <LoadingGroup.Placeholder fallback={<LoadingSkeleton style={{ width: 150, height: 20 }} />}>
          <Body size="small">{children}</Body></LoadingGroup.Placeholder>
      </LoadingGroup>
    </Stack>
  );
};
